import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const  CylInfoSearch = () => {
  const [serial, setSerial] = useState("");
  const [type, setType] = useState("order");
  const [productCode, setProductCode] = useState("");
  const [productOptions, setProductOptions] = useState([]);
  const [barcode, setBarcode] = useState("");

  useEffect(() => {
    const fetchProductCodes = async () => {
      const snapshot = await getDocs(collection(db, "cyl_info"));
      const codes = snapshot.docs.map(doc => ({
        id: doc.id,
        productCode: doc.data().productCode,
      }));
      setProductOptions(codes);
    };
    fetchProductCodes();
  }, []);

  const handleGenerate = () => {
    if (serial.length !== 6 || isNaN(serial)) {
      alert("Serial number must be 6 digits");
      return;
    }

    const selectedProduct = productOptions.find(
      (p) => p.productCode === productCode
    );

    if (!selectedProduct) {
      alert("Product code not found");
      return;
    }

    const prefix = type === "order" ? "49" : "50";
    const docIdPadded = selectedProduct.id.padStart(5, "0");

    const barcodeNum = `${serial}${prefix}${docIdPadded}`;
    setBarcode(barcodeNum);
  };

  return (
    <div className="max-w-md mx-auto p-4 space-y-4 bg-white shadow rounded">
      <div>
        <label className="block mb-1">Serial Number (6 digits)</label>
        <input
          type="text"
          value={serial}
          maxLength={6}
          onChange={(e) => setSerial(e.target.value.replace(/\D/g, ""))}
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <label className="block mb-1">Type</label>
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="order">Order</option>
          <option value="stock">Stock</option>
        </select>
      </div>

      <div>
        <label className="block mb-1">Product Code</label>
        <input
          type="text"
          list="productCodes"
          value={productCode}
          onChange={(e) => setProductCode(e.target.value)}
          className="w-full p-2 border rounded"
        />
        <datalist id="productCodes">
          {productOptions.map((p) => (
            <option key={p.id} value={p.productCode} />
          ))}
        </datalist>
      </div>

      <button
        onClick={handleGenerate}
        className="w-full bg-primary text-white py-2 rounded hover:bg-hover"
      >
        Generate Barcode Number
      </button>

      {barcode && (
        <div className="mt-4 p-3 bg-green-100 text-center rounded">
          <strong>Barcode Number:</strong><br />
          <span className="text-xl font-mono">{barcode}</span>
        </div>
      )}
    </div>
  );
};

export default CylInfoSearch;
